"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreePropertyGraphEditorModule = /** @class */ (function () {
    function TreePropertyGraphEditorModule() {
    }
    return TreePropertyGraphEditorModule;
}());
exports.TreePropertyGraphEditorModule = TreePropertyGraphEditorModule;
